// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/article-page-news-intro/article-page-news-intro.component.scss
// module id = 107
// module chunks = 0